module.exports = __webpack_public_path__ + "static/media/paciente.db0500b5.svg";